import { oraPrenotaStore } from "../oraPrenotaStore";

export function RouteGuard(props: { children: React.ReactNode }) {
  const { children } = props;
  const isAuthenticated = oraPrenotaStore((state) => state.isAuthenticated);

  if (!isAuthenticated) return <>Non si hanno le autorizzazioni!</>;

  return <>{children}</>;
}
